<template>
    <!-- 弹窗遮罩 -->
    <div class="lite_popup lite_preview" v-show="show">
        <!-- 弹窗 -->
        <div class="lite_popup_box">
            <!-- 标题栏 -->
            <div class="lite_popup_title">
                <!-- 标题 -->
                <span>Preview ({{ currentIndex + 1 }}/{{ files.length }}) <span style="margin-left:20px;">{{ cur.name }}</span></span>
                <!-- 关闭图标 -->
                <div class="icon white-close dialog-close" @click="close"></div>
            </div>
            <!-- 内容 -->
            <div class="lite_popup_content" v-if="show">
                <!-- 加载中 -->
                <div class="lite-preview-loading" v-show="fullscreenLoading"></div>
                <!-- 图片预览 -->
                <img v-if="isImage && sizeOKForImage" :src="previewUrl" class="preview_img" />
                <!-- 音频预览 -->
                <audio v-else-if="isAudio" :src="previewUrl" controls class="preview_audio"></audio>
                <!-- 视频预览 -->
                <video v-else-if="isVideo" :src="previewUrl" controls class="preview_video"></video>
                <!-- 邮件预览 -->
                <div v-else-if="isEml && sizeOKForEml" class="preview_eml">
                    <div class="preview_eml_header">
                        <div v-if="eml.subject" class="preview_eml_subject">{{ eml.subject }}</div>
                        <div class="preview_eml_meta" v-if="eml.from"><span>From:</span>{{ eml.from }}</div>
                        <div class="preview_eml_meta" v-if="eml.to"><span>To:</span>{{ eml.to }}</div>
                        <div class="preview_eml_meta" v-if="eml.cc"><span>Cc:</span>{{ eml.cc }}</div>
                        <div class="preview_eml_meta" v-if="eml.date"><span>Date:</span>{{ eml.date }}</div>
                    </div>
                    <iframe class="preview_eml_body" sandbox :srcdoc="eml.bodyHtml"></iframe>
                    <div class="preview_eml_attachments" v-if="eml.attachments.length">
                        <div class="preview_eml_attachments_title">Attachments ({{ eml.attachments.length }})</div>
                        <div class="preview_eml_attachment" v-for="(attachment, index) in eml.attachments" :key="index">
                            <span class="preview_eml_attachment_name">{{ attachment.name }}</span>
                            <span class="preview_eml_attachment_meta">{{ attachment.type }}<span v-if="attachment.size"> - {{ formatBytes(attachment.size) }}</span></span>
                        </div>
                    </div>
                </div>
                <!-- 文本预览 -->
                <pre v-else-if="isText && sizeOKForText" class="preview_text">{{ textContent }}</pre>
                <!-- 无法预览，显示属性 -->
                <div v-else class="preview_info">
                    <img src="../../assets/images/workspace/un_preview.png" draggable="false">
                    <div v-if="cur.dir"><b>{{ cur.name }}</b></div>
                    <div v-else>{{ cur.name }}<span v-if="cur.size"> - {{ formatBytes(cur.size) }}</span></div>
                    <div>{{ formatDate(cur.time) }}</div>
                    <div>{{$t('language.preview.fileNotReview')}}</div>
                </div>
            </div>
            <!-- 底部 -->
            <div class="lite_popup_footer">
                <!-- 按钮 -->
                <button @click="prev()" :disabled="currentIndex==0">Prev</button>
                <button @click="next()" :disabled="currentIndex+1==files.length">Next</button>
            </div>
        </div>
    </div>
</template>

<script>
import { Message } from "element-ui";
import requestUtils from '@/js/request_util.js';
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";

export default {
    props: {
        files: Array,
    },
    data() {
        return {
            show: false,
            currentIndex: 0,
            previewUrl: '',
            textContent: '',
            eml: {
                subject: '',
                from: '',
                to: '',
                cc: '',
                date: '',
                bodyHtml: '',
                attachments: [],
            },
            fullscreenLoading: false,
            previewLoadQueued: false,
        };
    },
    computed: {
        cur() {
            return this.files[this.currentIndex] || {};
        },
        ext() {
            return this.cur.name ? this.cur.name.split('.').pop().toLowerCase() : '';
        },
        isImage() {
            return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(this.ext);
        },
        isAudio() {
            return ['mp3', 'wav', 'ogg', 'aac'].includes(this.ext);
        },
        isVideo() {
            return ['mp4', 'mov', 'avi', 'mkv', 'webm', '3gp'].includes(this.ext);
        },
        isEml() {
            return this.ext == 'eml';
        },
        isText() {
            return ['txt', 'log', 'json', 'md', 'xml', 'yml', 'html', 'css', 'js', 'ini', 'java', 'py', 'sql'].includes(this.ext);
        },
        sizeOKForImage() {
            return !this.cur.size || this.cur.size < 10 * 1024 * 1024;
        },
        sizeOKForText() {
            return this.cur.size < 1 * 1024 * 1024;
        },
        sizeOKForEml() {
            return !this.cur.size || this.cur.size < 5 * 1024 * 1024;
        }
    },
    watch: {
        currentIndex() {
            this.queueLoadPreview();
        },
        show(v) {
            if (v) this.queueLoadPreview();
        }
    },
    methods: {
        // 获取节点路径
        getNodePath(node) {
            let path = '';
            let arr = this.getNodeArr(node);
            for (let i = 0; i < arr.length; i++) {
                let item = arr[i];
                path += '/' + item.name;
            }
            return path;
        },
        // 获取节点和父
        getNodeArr(node) {
            let arr = [];
            while (node) {
                arr.push(node);
                node = node.parent;
            }
            return arr.reverse();
        },
        // 格式化字节数
        formatBytes(value) {
            if (value === null || value === undefined) return '';
            if (value === 0) return '0Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
            const i = Math.floor(Math.log(value) / Math.log(k));
            const num = value / Math.pow(k, i);
            return Number.isInteger(num) 
                ? num + sizes[i] 
                : num.toFixed(2) + sizes[i];
        },
        // 格式化时间
        formatDate(value) {
            if (!value) return '';
            return commonUtils.i18nDateFormat(value, this.$i18n.locale);
        },
        close() {
            this.show = false;
        },
        prev() {
            if (this.currentIndex > 0) this.currentIndex--;
        },
        next() {
            if (this.currentIndex < this.files.length - 1) this.currentIndex++;
        },
        // 合并同一轮响应式更新，避免打开弹窗时重复加载预览
        queueLoadPreview() {
            if (this.previewLoadQueued) return;
            this.previewLoadQueued = true;
            this.$nextTick(() => {
                this.previewLoadQueued = false;
                if (this.show) this.loadPreview();
            });
        },
        async loadPreview() {
            this.previewUrl = '';
            this.textContent = '';
            this.eml = {
                subject: '',
                from: '',
                to: '',
                cc: '',
                date: '',
                bodyHtml: '',
                attachments: [],
            };
            if (!this.cur || this.cur.dir) return;
            try {
                this.fullscreenLoading = true;
                const url = await this.getDownLoadUrl(this.cur);
                this.previewUrl = url;
                // 文本文件读取
                if (this.isEml && this.sizeOKForEml) {
                    const res = await fetch(url);
                    const text = await res.text();
                    this.eml = this.parseEml(text);
                } else if (this.isText && this.sizeOKForText) {
                    const res = await fetch(url);
                    this.textContent = await res.text();
                }
            } catch (e) {
                console.error(e);
            } finally {
                this.fullscreenLoading = false;
            }
        },
        parseEml(text) {
            const root = this.parseMimePart(text);
            const body = {
                html: '',
                text: '',
                attachments: [],
            };
            this.collectEmlParts(root, body);
            const bodyHtml = body.html
                ? this.createEmlSrcdoc(this.sanitizeEmailHtml(body.html))
                : this.createEmlSrcdoc('<pre>' + this.escapeHtml(body.text || '') + '</pre>');
            return {
                subject: this.getHeader(root.headers, 'subject'),
                from: this.getHeader(root.headers, 'from'),
                to: this.getHeader(root.headers, 'to'),
                cc: this.getHeader(root.headers, 'cc'),
                date: this.getHeader(root.headers, 'date'),
                bodyHtml,
                attachments: body.attachments,
            };
        },
        parseMimePart(raw) {
            const normalized = (raw || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            const blankLine = normalized.match(/\n\s*\n/);
            const headerText = blankLine ? normalized.slice(0, blankLine.index) : '';
            const bodyText = blankLine ? normalized.slice(blankLine.index + blankLine[0].length) : normalized;
            const headers = this.parseEmailHeaders(headerText);
            const contentType = this.parseHeaderValue(this.getHeader(headers, 'content-type') || 'text/plain');
            const disposition = this.parseHeaderValue(this.getHeader(headers, 'content-disposition') || '');
            const part = {
                headers,
                contentType,
                disposition,
                body: bodyText,
                children: [],
            };
            if (contentType.value.indexOf('multipart/') == 0 && contentType.params.boundary) {
                const children = this.splitMimeMultipart(bodyText, contentType.params.boundary);
                part.children = children.map(item => this.parseMimePart(item));
            }
            return part;
        },
        parseEmailHeaders(headerText) {
            const headers = {};
            const lines = (headerText || '').split('\n');
            let current = '';
            for (let i = 0; i < lines.length; i++) {
                const line = lines[i];
                if (/^\s/.test(line) && current) {
                    current += ' ' + line.trim();
                } else {
                    if (current) this.addEmailHeader(headers, current);
                    current = line;
                }
            }
            if (current) this.addEmailHeader(headers, current);
            return headers;
        },
        addEmailHeader(headers, line) {
            const index = line.indexOf(':');
            if (index <= 0) return;
            const key = line.slice(0, index).trim().toLowerCase();
            const value = this.decodeMimeWords(line.slice(index + 1).trim());
            if (!headers[key]) headers[key] = [];
            headers[key].push(value);
        },
        getHeader(headers, key) {
            const values = headers && headers[key.toLowerCase()];
            return values && values.length ? values.join(', ') : '';
        },
        parseHeaderValue(value) {
            const result = {
                value: '',
                params: {},
            };
            const segments = (value || '').split(';');
            result.value = (segments.shift() || '').trim().toLowerCase();
            for (let i = 0; i < segments.length; i++) {
                const item = segments[i];
                const index = item.indexOf('=');
                if (index <= 0) continue;
                const key = item.slice(0, index).trim().toLowerCase().replace(/\*\d+\*?$/, '');
                let val = item.slice(index + 1).trim();
                val = val.replace(/^"|"$/g, '');
                if (val.indexOf("''") > -1) {
                    val = decodeURIComponent(val.split("''").pop());
                }
                result.params[key] = this.decodeMimeWords(val);
            }
            return result;
        },
        splitMimeMultipart(body, boundary) {
            const lines = (body || '').split('\n');
            const start = '--' + boundary;
            const end = start + '--';
            const parts = [];
            let current = null;
            for (let i = 0; i < lines.length; i++) {
                const line = lines[i].trim();
                if (line == start || line == end) {
                    if (current) parts.push(current.join('\n'));
                    current = line == end ? null : [];
                } else if (current) {
                    current.push(lines[i]);
                }
            }
            return parts;
        },
        collectEmlParts(part, result) {
            if (!part) return;
            if (part.children && part.children.length) {
                for (let i = 0; i < part.children.length; i++) {
                    this.collectEmlParts(part.children[i], result);
                }
                return;
            }
            const type = part.contentType.value || 'text/plain';
            const disposition = part.disposition.value || '';
            const filename = this.getMimeFilename(part);
            const isAttachment = disposition == 'attachment' || !!filename;
            const decoded = this.decodeMimeBody(part.body, this.getHeader(part.headers, 'content-transfer-encoding'), this.getMimeCharset(part));
            if (!isAttachment && type == 'text/html' && !result.html) {
                result.html = decoded;
                return;
            }
            if (!isAttachment && type == 'text/plain' && !result.text) {
                result.text = decoded;
                return;
            }
            if (isAttachment) {
                result.attachments.push({
                    name: filename || 'attachment',
                    type: type || 'application/octet-stream',
                    size: this.estimateMimeBodySize(part.body, this.getHeader(part.headers, 'content-transfer-encoding')),
                });
            }
        },
        getMimeFilename(part) {
            return (part.disposition.params && (part.disposition.params.filename || part.disposition.params.name))
                || (part.contentType.params && (part.contentType.params.name || part.contentType.params.filename))
                || '';
        },
        getMimeCharset(part) {
            return (part.contentType.params && part.contentType.params.charset) || 'utf-8';
        },
        decodeMimeBody(body, encoding, charset) {
            const transfer = (encoding || '').trim().toLowerCase();
            if (transfer == 'base64') {
                return this.decodeBase64Text(body, charset);
            }
            if (transfer == 'quoted-printable') {
                return this.decodeQuotedPrintableText(body, charset);
            }
            return body || '';
        },
        decodeMimeWords(value) {
            return (value || '').replace(/=\?([^?]+)\?([bqBQ])\?([^?]*)\?=/g, (match, charset, encoding, body) => {
                if (encoding.toLowerCase() == 'b') return this.decodeBase64Text(body, charset);
                return this.decodeQuotedPrintableText(body.replace(/_/g, ' '), charset);
            });
        },
        decodeBase64Text(value, charset) {
            try {
                const clean = (value || '').replace(/\s/g, '');
                const binary = atob(clean);
                return this.decodeBinaryString(binary, charset);
            } catch (e) {
                return value || '';
            }
        },
        decodeQuotedPrintableText(value, charset) {
            try {
                const clean = (value || '').replace(/=\n/g, '');
                let binary = '';
                for (let i = 0; i < clean.length; i++) {
                    if (clean[i] == '=' && /^[0-9a-fA-F]{2}$/.test(clean.substr(i + 1, 2))) {
                        binary += String.fromCharCode(parseInt(clean.substr(i + 1, 2), 16));
                        i += 2;
                    } else {
                        binary += clean[i];
                    }
                }
                return this.decodeBinaryString(binary, charset);
            } catch (e) {
                return value || '';
            }
        },
        decodeBinaryString(binary, charset) {
            if (!binary) return '';
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
            }
            try {
                if (window.TextDecoder) {
                    return new TextDecoder(charset || 'utf-8').decode(bytes);
                }
            } catch (e) {
                try {
                    return new TextDecoder('utf-8').decode(bytes);
                } catch (err) {}
            }
            return binary;
        },
        estimateMimeBodySize(body, encoding) {
            const transfer = (encoding || '').trim().toLowerCase();
            const clean = (body || '').replace(/\s/g, '');
            if (transfer == 'base64') {
                return Math.floor(clean.length * 3 / 4);
            }
            return (body || '').length;
        },
        sanitizeEmailHtml(html) {
            const container = document.createElement('div');
            container.innerHTML = html || '';
            const blocked = container.querySelectorAll('script, iframe, object, embed, link, meta, base');
            for (let i = blocked.length - 1; i >= 0; i--) {
                blocked[i].parentNode.removeChild(blocked[i]);
            }
            const nodes = container.querySelectorAll('*');
            for (let i = 0; i < nodes.length; i++) {
                const attrs = nodes[i].attributes;
                for (let j = attrs.length - 1; j >= 0; j--) {
                    const attr = attrs[j];
                    const name = attr.name.toLowerCase();
                    const value = attr.value || '';
                    if (name.indexOf('on') == 0 || /^\s*javascript:/i.test(value)) {
                        nodes[i].removeAttribute(attr.name);
                    }
                }
            }
            return container.innerHTML;
        },
        createEmlSrcdoc(content) {
            return '<!doctype html><html><head><meta charset="utf-8"><style>body{font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:1.5;color:#333;margin:16px;}img{max-width:100%;height:auto;}pre{white-space:pre-wrap;word-break:break-word;font-family:Consolas,Menlo,monospace;}</style></head><body>' + (content || '') + '</body></html>';
        },
        escapeHtml(value) {
            return (value || '').replace(/[&<>"']/g, (char) => {
                return {
                    '&': '&amp;',
                    '<': '&lt;',
                    '>': '&gt;',
                    '"': '&quot;',
                    "'": '&#39;',
                }[char];
            });
        },
        async getDownLoadUrl(node) {
            const uuid = await this.prepareDownload(node);
            return `${commonstate.liteUrl}/lite/file/downloadFile?uuid=${uuid}`;
        },
        prepareDownload(node) {
            return new Promise((resolve) => {
                this.sendRequest(
                    "/file/download",
                    {
                        id: this.$store.state.curDriveId,
                        param: { node },
                    },
                    (data) => resolve(data)
                );
            });
        },
        sendRequest(path, data, callback) {
            requestUtils.doLiteRequest(path, data).then(
                (res) => {
                    let code = res.code;
                    let msg = res.msg || res.message;
                    if (code === 200) {
                        callback && callback(res.data);
                    } else if (code === 400) {
                        Message.warning(msg);
                    } else {
                        Message.error(msg);
                    }
                },
                (err) => Message.error(err)
            );
        },
    }
};
</script>

<style scoped>
/* 弹窗宽度 */
.lite_popup_box {
    width: 1300px;
    height: 800px;
}

/* 弹窗内容高度 */
.lite_preview .lite_popup_content {
    height: calc(100% - 150px);
    text-align: center;
    position: relative;
}

/* 按钮布局 */
.lite_popup_footer {
    text-align: center;
}

.preview_img, .preview_video, .preview_audio {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
}
.preview_audio {
    height: calc(50% + 30px);
}
.preview_text {
    text-align: left;
    white-space: pre-wrap;
    overflow: auto;
    height: 100%;
}

.preview_eml {
    height: 100%;
    text-align: left;
    background: #fff;
    color: #333;
    display: flex;
    flex-direction: column;
}

.preview_eml_header {
    padding: 14px 18px;
    border-bottom: 1px solid #e6e9f0;
    flex: 0 0 auto;
}

.preview_eml_subject {
    font-size: 18px;
    line-height: 24px;
    font-weight: bold;
    margin-bottom: 8px;
    color: #1f2d3d;
}

.preview_eml_meta {
    font-size: 13px;
    line-height: 22px;
    color: #606266;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.preview_eml_meta span {
    display: inline-block;
    width: 48px;
    color: #909399;
}

.preview_eml_body {
    width: 100%;
    flex: 1 1 auto;
    border: 0;
    background: #fff;
}

.preview_eml_attachments {
    flex: 0 0 auto;
    max-height: 120px;
    overflow: auto;
    padding: 10px 18px;
    border-top: 1px solid #e6e9f0;
    background: #fafafa;
}

.preview_eml_attachments_title {
    font-weight: bold;
    font-size: 13px;
    margin-bottom: 6px;
    color: #1f2d3d;
}

.preview_eml_attachment {
    font-size: 13px;
    line-height: 24px;
    display: flex;
    justify-content: space-between;
    gap: 20px;
}

.preview_eml_attachment_name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.preview_eml_attachment_meta {
    color: #909399;
    white-space: nowrap;
}

.preview_info {
    margin: 180px 300px;
    text-align: center;
    border-radius: 4px;
}

.preview_info>div {
    margin-top: 5px;
    height: 30px;
    line-height: 30px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #6f7886;
}

video {
    background-color: #000;
}

/* 加载中 */
.lite-preview-loading {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 简洁圆环旋转动画 */
.lite-preview-loading::after {
    content: "";
    width: 48px;
    height: 48px;
    border: 4px solid #DCE4F5;
    border-top-color: #5562B4;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/lite_preview.vue